module.exports = __webpack_public_path__ + "img/blocking.767dba83.svg";